module.exports = __webpack_public_path__ + "static/media/quarrytruck2.1d4a7273.jpg";